import { createRouter, createWebHashHistory } from 'vue-router'

import { localCache } from '@/utils/cache'
import { firstMenuItem } from '@/utils/map/mapMenuToRoute'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.VITE_PREFIX_URL),
  routes: [
    { path: '/', redirect: '/main' },
    { path: '/login', component: () => import('@/views/Login/Login.vue') },
    { path: '/main', name: 'main', component: () => import('@/views/Main/Main.vue') },
    { path: '/:pathMatch(.*)', component: () => import('@/views/NotFound/NotFound.vue') }
  ]
})

router.beforeEach((to, from) => {
  const token = localCache.getCache('token') ?? ''
  // 如果进入main页面，但是没有token
  if (to.path === '/main' && !token) {
    router.push('/login')
  }

  // 如果进入main页面，
  if (/^\/main\/?$/.test(to.path)) {
    if (firstMenuItem) router.push(firstMenuItem.url)
  }
})

export default router
